import * as React from "react";
const SvgFiRrSaltPepper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-salt-pepper_svg__a)">
      <path
        fill="#062147"
        d="M21.832 11.445A7.8 7.8 0 0 1 20 6a1 1 0 1 0 0-2c-.138-5.276-7.863-5.272-8 0a1 1 0 1 0 0 2 7.8 7.8 0 0 1-1.832 5.445 8.85 8.85 0 0 0-1.3 9.445A4.99 4.99 0 0 0 13.5 24h5c3.761.121 5.506-4 5.5-7a9.85 9.85 0 0 0-2.168-5.555M16 2a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2m2 4a8.5 8.5 0 0 0 1.188 5h-6.377a8.5 8.5 0 0 0 1.19-5zm3.271 14.155A2.975 2.975 0 0 1 18.501 22h-5c-2.569.147-3.48-3.224-3.5-5a7.24 7.24 0 0 1 1.536-4h8.926a6.55 6.55 0 0 1 .808 7.155M8.001 23c-.036 1.327-1.642.953-2.5 1-3.765.122-5.507-4-5.5-7-.043-4.5 4.508-6.634 4-11a1 1 0 1 1 0-2 4.025 4.025 0 0 1 6.666-2.98 1 1 0 0 1-1.334 1.49A2.012 2.012 0 0 0 6 4h2a1 1 0 0 1 0 2H6a8.5 8.5 0 0 1-1.189 5h2.19a1 1 0 1 1 0 2H3.536a6.55 6.55 0 0 0-.809 7.155A2.98 2.98 0 0 0 5.5 22H7a1 1 0 0 1 1 1m10-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-salt-pepper_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSaltPepper;
